import React from "react";
import PropTypes from "prop-types";

// A product with no uploaded image carries a generated dicebear default (coalesced in by both the
// Algolia hit and the product-page API), which is also what ProfileImage keys its create-vs-update
// logic on. A URL that is absent or dicebear means "no image of its own".
export const isPlaceholderProductImage = (url) => !url || url.startsWith("https://api.dicebear.com/");

// The empty-state product image: a gray tile with a centered white price-tag glyph. The tile fills
// its parent; `iconFontSize` sizes the tag per call site (a 220px card band vs. a 56px list thumb
// vs. a 160px profile avatar).
function ProductImagePlaceholder({ radius = 4, iconFontSize = "2.5rem" }) {
  return (
    <div
      aria-label="No product image"
      style={{
        width: "100%",
        height: "100%",
        borderRadius: radius,
        background: "#C4C8CE",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <i className="fa-solid fa-tag" style={{ color: "#FFFFFF", fontSize: iconFontSize }} aria-hidden="true" />
    </div>
  );
}

ProductImagePlaceholder.propTypes = {
  radius: PropTypes.number,
  iconFontSize: PropTypes.string,
};

export default ProductImagePlaceholder;
